import { getBackendBaseUrl } from "@/utils/backend-base-url";
import { atom } from "jotai";

export const baseUrlAtom = atom(getBackendBaseUrl());
baseUrlAtom.debugLabel = "baseUrlAtom";
